import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  leaves: [],
  transactions: [],
  listLoading: false,
  actionsLoading: false,
  error: null,
};

export const callTypes = {
  list: "list",
  action: "action",
};

export const Slice = createSlice({
  name: "leave",
  initialState,
  reducers: {
    
    catchError: (state, action) => {
      state.error = action.payload?.err || "Bilinmeyen hata.";
      state.listLoading = false;
      state.actionsLoading = false;
      console.error("Leave Slice Error:", state.error); 
    },

  
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },

    
    createAsk: (state, action) => {
      state.error = null;
      state.listLoading = false;
      state.leaves.push(action.payload);
    },

    
    gets: (state, action) => {
      state.error = null;
      state.listLoading = false;
      state.leaves = action.payload || [];
    },

   
    updateAll: (state, action) => {
      state.error = null;
      state.leaves = action.payload || [];
    },

    
    update: (state, action) => {
      state.error = null;
      const updatedLeave = action.payload.leave || action.payload;
      const id = updatedLeave.id || updatedLeave._id;
      const index = state.leaves.findIndex((l) => l.id === id || l._id === id);
      if (index !== -1) state.leaves[index] = updatedLeave;
    },

    
    remove: (state, action) => {
      state.error = null;
      const id = action.payload.id || action.payload._id;
      state.leaves = state.leaves.filter(
        (l) => l.id !== id && l._id !== id
      );
    },

    
    addAll: (state, action) => {
      state.error = null;
      state.leaves = [...state.leaves, ...(action.payload || [])];
    },

    
    add: (state, action) => {
      state.error = null;
      state.leaves.push(action.payload);
    },

    
    transactions: (state, action) => {
      state.error = null;
      state.transactions = action.payload || [];
    },

    removeTransaction: (state, action) => {
      state.error = null;
      const id = action.payload?._id || action.payload;
      state.transactions = state.transactions.filter(
        (t) => t._id !== id);
    },
  },
});
